// src/pages/Facilities/Facilities.tsx
import React, { useState, useEffect, Fragment } from 'react';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import styles from './styles.module.sass';
import Page from '../../layouts/Page';
import TextBlock from '../../components/TextBlock';
import { hostname } from '../../constants';

interface FacilityEntry {
  name: string;
  description: string;
  image: {
    ID: number;
    sizes: {[key: string]: string};
  };
}

const Facilities: React.FC = () => {
  const params = useParams<Record<string, string>>();
  const country = params.country || '';
  const [data, setData] = useState<FacilityEntry[]>([]);

  useEffect(() => {
    if (!country) return;
    fetch(`${hostname}/${country}/wp-json/wp/v2/pages/10?_embed`)
      .then(res => res.json())
      .then((pageJson: any) => {
        const facilities: FacilityEntry[] = pageJson.acf.facility || [];
        setData(facilities);
      })
      .catch(console.error);
  }, [country]);

  if (data.length === 0) return null;

  return (
    <Page type="local" className={styles.base} country={country}>
      <div className={styles.feature}>
        {data.map(facility => (
          <Fragment key={facility.image.ID}>
            <h2>{facility.name}</h2>
            <img src={facility.image.sizes['twentyseventeen-featured-image']} alt="" />
            <TextBlock width={725}>
              {parse(facility.description)}
            </TextBlock>
          </Fragment>
        ))}
      </div>
    </Page>
  );
};

export default Facilities;
